<template>
    <v-dialog v-model="dialog" scrollable max-width="600px" hide-overlay>
        <template v-slot:activator="{ on }">
            <v-btn color="secondary" class="text-lowercase mr-4" dark small v-on="on">add resources</v-btn>
        </template>
        <v-card v-if="!loading">
            <v-card-title class="subtitle-2 pt-6 text-pre-wrap">
                New resources by game id: <span class="secondary--text">{{ set?.value }}</span> 
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text class="black--text">
                <v-container grid-list-md>
                    <v-form v-model="valid" ref="form" validation>
                        <v-row>
                            <v-col cols="12" md="4" sm="6">
                                <v-select dense return-object v-model="team"
                                    :items="teams" item-text="name" item-value="id"
                                    item-color="secondary" label="Team" 
                                    @change="onceMore()" 
                                    :rules="[rules.required]">
                                </v-select>
                            </v-col>
                            <v-col cols="12" sm="6" md="3">
                                <v-text-field dense color="secondary"
                                    label="Capacities current round"
                                    suffix="units"
                                    v-model="capacities" 
                                    name="capacities" type="text"
                                    readonly>
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="3">
                                <v-text-field dense color="secondary" 
                                    label="Production assets"
                                    prefix="$"
                                    v-model="production_assets" 
                                    name="production_assets" type="text"
                                    readonly>
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="3">
                                <v-text-field dense color="secondary" 
                                    label="Retail assets"
                                    prefix="$"
                                    v-model.number="retail_assets" 
                                    name="retail_assets" type="text"
                                    readonly>
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="3">
                                <v-text-field dense color="secondary" 
                                    label="Fixed assets"
                                    v-model.number="fixed_assets"
                                    prefix="$"
                                    name="fixed_assets" type="text"
                                    readonly>
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="3">
                                <v-text-field dense color="secondary" 
                                    label="Cash"
                                    v-model.number="cash"
                                    prefix="$"
                                    name="cash" type="text"
                                    readonly>
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="3">
                                <v-text-field dense color="secondary" 
                                    label="Long-term debt"
                                    prefix="$"
                                    v-model.number= "long_term_debt" 
                                    name="debt" type="text"
                                    readonly>
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="3">
                                <v-text-field dense color="secondary" 
                                    label="Contributed capital"
                                    prefix="$"
                                    v-model.number= "contributed_capital" 
                                    name="contributed_capital" type="text"
                                    readonly>
                                </v-text-field>
                            </v-col>
                            <!-- <v-col cols="12" sm="6" md="3">
                                <v-text-field dense color="secondary" 
                                    label="Borrowins this round"
                                    prefix="$"
                                    :hint="borrowHint"
                                    v-model.number="borrowings" 
                                    name="borrow" type="text"
                                    readonly>
                                </v-text-field>
                            </v-col>  -->  
                        </v-row>
                    </v-form>
                </v-container>
                <v-row justify="center" class="error--text">{{ error }}</v-row>
                <v-row justify="center" class="text-pre-wrap subtitle-2">
                    {{ message }}
                </v-row>    
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="secondary" text class="text-capitalize" :disabled="Boolean(error)"
                    @click="addResource">Save
                </v-btn>

                <v-btn color="secondary" text class="text-capitalize" @click="closeDialog">
                    Close
                </v-btn>

            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { convertToNumber, localeNumber } from '../../../functions/common.js';

export default {
    name: 'AddResource',
    props: ['set', 'round'],
    data() {
        return {
            dialog: false,
            valid: false,
            error: '',
            message: '',
            rules: {
                required: v => !!v || 'this field is required',
            },
            //props
            team: null,
            retail_assets: 0,
            fixed_assets: 0,
            cash: 0,
            long_term_debt: 0,
            capacities_increase: 0,
            contributed_capital: 0,
            accumulated_depreciation: 0,
            borrowings: 0,
        }
    },
    computed: {
        loading() {
            return this.$store.getters.loading
        },
        locale() {
            return this.$store.getters.locale;
        },
        teams() {
            return this.$store.getters.teams;
        },
        market_segments() {
            return this.$store.getters.market_segments;
        },
        channels() {
            return this.$store.getters.channels_all;
        },
        capacities: {
            get() {
                let res = 0;
                if (this.market_segments?.length > 0) {
                    res = this.market_segments.reduce((sum, seg) => {
                        return sum += seg.segment.peak_size;
                    }, 0)
                }
                return this.formatNumber(Math.round(res * 0.2), this.locale); // 20%
            },
            set(val) {
                return val;
            } 
        },
        production_assets() {
            if (this.capacities) {
                let _capacities = convertToNumber(this.capacities)               
                return this.formatNumber(_capacities * 100, this.locale);
            }
            return 0;
        },
        
        borrowHint() {
           return `not more than $${localeNumber(this.fix_assets * 0.7 - this.debt, this.locale)}`;
        }  
    },
    watch: {
       async set() {
            const obj = {
                gameId: Number(this.set.value),
                round: Number(this.round),
            }
            try {
                await this.$store.dispatch('fetchTeams', this.set.value);
                await this.$store.dispatch('fetchMarketSegments', obj);
                await this.$store.dispatch('fetchChannels', obj);
            }
            catch (error) {
                /* console.log(error) */ 
                await this.$store.dispatch('setError', error.message) 
            }
        }, 
        team() {
            /* retail_assets */
            let _retail_assets = 0;
            const team_channels = this.channels?.filter((chan) => (chan.teamId == this.team?.id && Number(chan.type) < 4))
            
            if (team_channels?.length > 0) {
                _retail_assets = team_channels.reduce((sum, item) => {
                    return sum+= item.investment_costs;
                }, 0)
            }
            /* console.log(this.retail_assets) */
            
            let prod_assets = convertToNumber(this.production_assets);
            let _fixed_assets = _retail_assets + prod_assets; /* fixed_assets */
            let _cash = _fixed_assets / 4;
            let _debt = _fixed_assets * 0.4;
            let _contributed = _fixed_assets + _cash - _debt;


            this.retail_assets = localeNumber(_retail_assets, this.locale);
            this.fixed_assets = localeNumber(_fixed_assets, this.locale);
            this.cash = localeNumber(_cash, this.locale);
            this.long_term_debt = localeNumber(_debt, this.locale);
            this.contributed_capital = localeNumber(_contributed, this.locale);
        }
    }, 
    methods: {
        formatNumber(num) {
            return localeNumber(num, this.locale);
        },
        onceMore() {
            this.error = ''
            this.calculate = false;
            this.message = '';
            this.capacities = () => {
                let res = 0;
                if (this.market_segments?.length > 0) {
                    res = this.market_segments.reduce((sum, seg) => {
                        return sum += seg.segment.peak_size;
                    }, 0)
                }
                return res * 0.2;
            }
        },
        async addResource() {

            if (this.$refs.form.validate()) {
                /*const segments = this.pick_segments.map(seg => seg.segment.name);*/

                const resource = {
                    gameId: Number(this.set.value),
                    round: Number(this.round),
                    team: this.team,
                    capacities: convertToNumber(this.capacities),
                    long_term_debt: convertToNumber(this.long_term_debt),
                }

               /*console.log('resource: ', resource);*/

                const intermediary = {
                    gameId: Number(this.set.value), 
                    round: Number(this.round),
                    teamId: this.team.id,
                    production_assets: convertToNumber(this.production_assets),
                    retail_assets: convertToNumber(this.retail_assets),
                    production_depreciation: 0,
                    retail_depreciation: 0,
                    franchise_cost: 0,
                    franchise_fee: 0,
                    retail_entry: 0,
                    retail_annual_fee: 0,
                    invest_assets: 0,
                    market_research: 0,
                }  
               /*console.log('intermediary: ', intermediary); */
                
                const finances = {
                    gameId: Number(this.set.value),
                    round: Number(this.round),
                    team: this.team,
                    fixed_assets: convertToNumber(this.fixed_assets),
                    cash: convertToNumber(this.cash),
                    contributed_capital: convertToNumber(this.contributed_capital),
                    long_term_debt: convertToNumber(this.long_term_debt),
                    accumulated_depreciation: this.accumulated_depreciation,
                } 
                /*console.log('finance: ',finances);*/
                
                try {
                    /* add resource */
                    await this.$store.dispatch('addResource', resource);
                }
                catch (error) {
                    this.$store.dispatch('showSnackbar', {
                        on: true,
                        color: 'secondary',
                        text: `Error adding the resource : ${error.message}`,
                        timeout: 2000
                    })
                }
                try {
                    /* add intermediary */
                    await this.$store.dispatch('addIntermediary', intermediary);
                }
                catch (error) {
                    this.$store.dispatch('showSnackbar', {
                        on: true,
                        color: 'secondary',
                        text: `Error adding the intermediary : ${error.message}`,
                        timeout: 2000
                    })
                }
                try {
                    /* add finances */
                    await this.$store.dispatch('addFinances', finances);
                }
                catch (error) {
                    this.$store.dispatch('showSnackbar', {
                        on: true,
                        color: 'secondary',
                        text: `Error adding the finances : ${error.message}`,
                        timeout: 2000
                    })
                }
                        
                this.closeDialog()
                this.message = '';
                 
            } 
        },
        closeDialog() {
            //reset
            this.dialog = false;
            this.error = '';
            this.message = '';
            this.team = null;
            this.retail_assets = 0;
            this.fixed_assets = 0;
            this.cash = 0;
            this.long_term_debt = 0;
            this.capacities_increase = 0;
            this.contributed_capital = 0;
            this.accumulated_depreciation = 0;
            this.borrowings = 0;
        }
    },
    async mounted() {
        const obj= {
            gameId: Number(this.set.value),
            round: Number(this.round),
        }
        if (this.teams?.length < 1) {
            try {
                await this.$store.dispatch('fetchTeams', this.set.value);
            }
            catch (error) {
                await this.$store.dispatch('setError', error.message)
            }
        }
        if (this.market_segments?.length < 1) {
            try {
                await this.$store.dispatch('fetchMarketSegments', obj)
            }
            catch (error) {
                await this.$store.dispatch('setError', error.message)
            }
        }
        if (this.channels?.length < 1) {
            try {
                await this.$store.dispatch('fetchChannels', obj);
            }
            catch (error) {
                await this.$store.dispatch('setError', error.message)
            }
        }
    }
}
</script>